// extracted by mini-css-extract-plugin
module.exports = {"c-breadcrumbs":"Breadcrumbs_c-breadcrumbs__ROTv1"};